/**
 * Checks if an aircraft type is a Boeing aircraft.
 * 
 * Aircraft type naming convention:
 * - Boeing aircraft: Start with 'B' (e.g., 'B737', 'B757', 'B767', 'B787 MAX')
 * - Airbus aircraft: Start with 'A' (e.g., 'A320', 'A330')
 * 
 * This is used to conditionally hide IDMR links for Boeing aircraft,
 * as IDMR is only applicable to Airbus aircraft in the maintenance system.
 * 
 * @param aircraftType - The aircraft type string (e.g., 'B737', 'A320')
 * @returns true if the aircraft is a Boeing (starts with 'B') or is a Boeing max 737, false otherwise
 * 
 * @example
 * ```ts
 * isBoeingAircraft('B737')  // true
 * isBoeingAircraft('A320')  // false
 * isBoeingAircraft(null)    // false
 * isBoeingAircraft(undefined) // false
 * ```
 */

export function isBoeingAircraft(aircraftType: string | null | undefined): boolean {
    return (aircraftType?.startsWith('B') && !aircraftType?.includes('737')) ?? false;
}